module.exports = __webpack_public_path__ + "static/jc04657-preparation-administration-2-ec905cf815406fa5feb356d4ac2dfe0a.png";